<div style="padding: 10px">
  <p>You want to propose offer:</p>
  <br />
  <mat-radio-group [(ngModel)]="selectedOption">
    <mat-radio-button [value]="elem" *ngFor="let elem of options">{{ elem }}</mat-radio-button>
  </mat-radio-group>
  <div class="button-group">
    <button mat-raised-button (click)="onSubmit()">Ok</button>
    <button mat-raised-button (click)="dialogRef.close()">Cancel</button>
  </div>
</div>
